<template>
  <teleport to="body">
    <div v-if="isVisible" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-delete" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">{{ header }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hideModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img src="../../assets/gifs/TrashGif.gif" alt="Trash" height="90">
              <p class="mb-0" style="font-size: 16px; margin-top: 15px;">{{ $t('general.delete_question') }}</p>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" class="btn btn-grey mr-2" @click="hideModal">{{ $t('general.button.no') }}</button>
            <button type="button" class="btn btn-danger ml-2 pl-4 pr-4" @click="handleDelete">{{ $t('general.button.yes_delete') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isVisible" class="modal-backdrop fade show"></div>
  </teleport>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  header: {
    type: String,
    default: 'Title',
  },
  onDelete: {
    type: Function,
    default: () => {
    },
  },
});

const isVisible = ref(props.modelValue);

watch(() => props.modelValue, (newVal) => {
  isVisible.value = newVal;
});

const emit = defineEmits([ 'update:modelValue' ]);

const hideModal = () => {
  emit('update:modelValue', false);
};

const handleDelete = () => {
  if (props.onDelete) {
    props.onDelete();
  }
};
</script>

<style scoped>
</style>